import React from "react";
import {connect} from "src/store";
import Box from "../../layout/Box";
import PropsProxy from "../../layout/PropsProxy";

class TillBasedContext extends React.Component<{till?: {id?: number|string|null}}, any> {

    render() {
        if (!this.props?.till?.id) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy kasszába!
            </Box>;
        }
        return <PropsProxy till={this.props.till}>
            {this.props.children}
        </PropsProxy>;
    }

}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(TillBasedContext);